export const getHighestDiscount = (denominations = []) => {

  if (!Array.isArray(denominations) || denominations.length === 0) {
    return 0;
  }

  const percentageDiscounts = denominations
    .filter(
      (item) =>
        item?.valueType === "PERCENTAGE" &&
        item?.value > 0
    )
    .map((item) => item.value);

  return percentageDiscounts.length
    ? Math.max(...percentageDiscounts)
    : 0;
};

export const isDiscountedProduct = (discount) => {
  if (discount) {
    return {
      productType: 'Discount',
      discount: discount,
    };
  } else {
    return {
      productType: 'Discount',
      discount: discount,
    };
  }
};

export function sortByKey(data, key, order = 'asc') {
  if (!Array.isArray(data)) return null;

  return data?.slice().sort((a, b) => {
    let valA = a[key];
    let valB = b[key];

    // Convert to Date if the key is likely a date string
    if (key.toLowerCase().includes('date') || key.includes('created_at')) {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    if (valA < valB) return order === 'asc' ? -1 : 1;
    if (valA > valB) return order === 'asc' ? 1 : -1;
    return 0;
  });
}

export function extractTitleAndDate(data) {
  if (!Array.isArray(data)) {
    throw new Error('Input must be an array');
  }

  return data.map(({ title, created_at }) => ({
    title,
    created_at,
  }));
}

export async function blogCategoryFilter(data, key, category) {
  if (!Array.isArray(data)) {
    return null;
  }

  if (!key || typeof key !== 'string') {
    throw new Error('A valid key must be provided');
  }

  if (typeof category === 'undefined' || category === null) {
    return data; // No filtering if category is not defined
  }

  return data.filter((item) => {
    // Make sure the key exists in the item
    if (!(key in item)) return false;

    // Compare by string match (case insensitive)
    return String(item[key]).toLowerCase() === String(category).toLowerCase();
  });
}

export const isValidInputAscii = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    const isNumber = code >= 48 && code <= 57;
    const isHyphen = code === 45;

    if (!isLetter && !isNumber && !isHyphen) {
      return false;
    }
  }
  return true;
};

export const isValidInputAsciiWithSpace = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    const isNumber = code >= 48 && code <= 57;
    const isHyphen = code === 45;
    const isSpace = code === 32;

    if (!isLetter && !isNumber && !isHyphen && !isSpace) {
      return false;
    }
  }
  return true;
};

export const voucherBarCode = (voucherNo, voucherPin, voucherVal) => {
  if (voucherVal == true) {
    return voucherPin || null;
  }
  return voucherNo || null;
};

export const getUniqueClass = (id, title) => {
  return `${title?.slice(0, 4)?.trim()?.toUpperCase()}-${id}`;
};

// helping to show good in ui  comming from api html response data
export const renderHTML = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return div.textContent || div.innerText || "";
};

export const extractDiscount = (denomination) => {
  if (denomination?.userProductDenominationDiscounts?.length) {
    return denomination?.userProductDenominationDiscounts?.[0]?.discountValue;
  }

  return denomination?.['value'];

}

export const toTitleCase = (text = "") => {
  return text
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};


export const capitalizeFirst = (text = "") =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();




// src/utils/cleanSearchParams.js

/**
 * Builds a clean query string.
 * Arrays are joined with "+" (no %2C, no %5B%5D).
 * Example:
 *   { categorySlug: ["apparel", "e-gift-cards"], page: 2 }
 *     -> "categorySlug=apparel+e-gift-cards&page=2"
 */
export const buildCleanSearchString = (paramsObject) => {
  const parts = [];

  Object.entries(paramsObject).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value) && value.length === 0) return;

    const encoded = Array.isArray(value)
      ? value.map(encodeURIComponent).join("+")
      : encodeURIComponent(String(value));

    parts.push(`${key}=${encoded}`);
  });

  return parts.join("&");
};

/**
 * Convert the current URLSearchParams into a plain object.
 * Arrays that were "+"-joined are returned as arrays.
 */
export const ARRAY_KEYS = ["categorySlug", "brandIds"];

export const searchParamsToObject = (searchParams) => {
  const obj = {};

  searchParams.forEach((value, key) => {
    if (ARRAY_KEYS.includes(key)) {
      obj[key] = value
        .split("+")
        .map(decodeURIComponent)
        .filter(Boolean);
    } else {
      obj[key] = value;
    }
  });

  return obj;
};


export const readArrayParam = (searchParams, key) => {
  const raw = searchParams.get(key);
  if (!raw) return [];
  return raw
    .split("+")
    .map((v) => decodeURIComponent(v))
    .filter(Boolean);
};


export const CATEGORY_ORDER = [
  "Apparel",
  "Footwear",
  "E-Commerce",
  "Jewellery",
  "Entertainment",
  "Accessories",
  "Gaming",
  "Electronic",
  "Furniture",
  "Travel",
  "Health",
  "Food & Beverage",
  "Grocery",
  "Mall",
  "Cinema",
];


export const sortCategoriesByOrder = (categories = []) =>
  CATEGORY_ORDER
    .map((categoryName) =>
      categories?.find(
        (item) =>
          item?.name?.trim().toLowerCase() === categoryName.toLowerCase()
      )
    )
    .filter(Boolean);